export default __webpack_public_path__ + "static/media/title_bg.a81a422a.svg";